<template>
  <!--轮播图组件-->
  <div class="img-box">
    <van-swipe @change="toggleImage" :autoplay="3000">
      <van-swipe-item
        v-for="(s, num) in bannerImage"
        :key="num"
        @click.native="nextProductDetails(s)"
      >
        <img
          class="tkImage"
          :style="{width: width + '%', height: height + 'px'}"
          :src="s.image"
        >
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    bannerImage: {
      type: Array,
      required: true
    }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  computed: {
  },
  methods: {
    toggleImage (index) {
      if (this.bannerImage.length === 1) { this.$emit('changeIndex', 0) } else {
        this.$emit('changeIndex', index)
      }
    },
    nextProductDetails (s) {
      if (!s.link) { return }
      this.$push({ path: '/commodity/productDetails', query: { id: s.link } })
    }
  }
}
</script>

<style lang="scss" scoped>
  /*轮播图样式*/
  .img-box {
    padding: 0 12px;
    .tkImage {
      object-fit: cover;
      border-radius: 5px;
    }
  }
  ::v-deep {
    .van-swipe__indicator {
      width: 4px;
      height: 4px;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 50%;
    }
    .van-swipe__indicator--active {
      width: 8px;
      height: 4px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
  }
</style>
